module.exports = __webpack_public_path__ + "static/media/ne-NP.065e841a.md";